import { jsx as _jsx } from "react/jsx-runtime";
import { useBrandContext } from "@/shared/contexts";
import { Box } from "@gemini/core";
import { brandLogoMap } from "./constants";
export const AdFallbackIcon = () => {
    const brand = useBrandContext();
    const getLogoIcon = (type) => {
        var _a;
        return (_a = brandLogoMap[type]) !== null && _a !== void 0 ? _a : null;
    };
    return _jsx(Box, { position: "absolute", children: getLogoIcon(brand.brand) });
};
